import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth-service/auth.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as moment from 'moment-timezone';
import { SocketService } from '../socket-service/socket-service.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import { UserRoles } from 'src/app/component/shared/layout/menu-service/menu.service';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';

@Injectable()
export class AuthorizationGuard implements CanActivate {
  constructor(
    private assignTripService: AssigTripsService,
    private authService: AuthService,
    private socket: SocketService,
    private sharedDataService: SharedDataService,
    private router: Router
  ) {
  }

  // @ts-ignore
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserLogin(next);
  }
  // all roles
  checkUserLogin(route: ActivatedRouteSnapshot) {
    const storedLastActive = localStorage.getItem('last_activity_time');
    const INACTIVITY_LIMIT_MS = 30 * 60 * 1000;

    return this.authService.VerifyToken()
      .pipe(
        map((data: any) => {
          if (data.user) {
            const user = data.user;
            const isAutoLogout = (user.hasOwnProperty('isAutoLogout') && user.isAutoLogout) ||
                                 (user.company && user.company.hasOwnProperty('isAutoLogout') && user.company.isAutoLogout);
            if (isAutoLogout && storedLastActive) {
              const parsedLastActive = parseInt(storedLastActive, 10);
              if (!isNaN(parsedLastActive) && parsedLastActive > 0) {
                const elapsed = Date.now() - parsedLastActive;
                if (elapsed >= INACTIVITY_LIMIT_MS) {
                  // Inactivity limit exceeded for company with Auto Logout enabled
                  this.socket.disconnectSocket();
                  this.authService.removeToken();
                  this.authService.removeAuthToken();
                  this.sharedDataService.saveUser(null);
                  localStorage.removeItem('last_activity_time');
                  this.router.navigate(['/login']);
                  return false;
                }
              }
            }
            const isAccountInactive = user.hasOwnProperty('accountStatus') && user.accountStatus === 'inactive';
            const isForceLogout = user.hasOwnProperty('isForceLogout') && user.isForceLogout;
            const isDisallowMultiLogin = user.hasOwnProperty('disallowMultiLogin') && user.disallowMultiLogin;
            let isAuthTokenMismatched = false;
            if (isDisallowMultiLogin) {
              const authToken = user.authToken;
              const savedAuthToken = this.authService.getAuthToken();
              if (authToken && savedAuthToken) {
                isAuthTokenMismatched = authToken !== savedAuthToken;
              } else {
                isAuthTokenMismatched = true;
              }
            }
            if (isAccountInactive || isForceLogout ||  (isDisallowMultiLogin && isAuthTokenMismatched)) {
              this.socket.disconnectSocket();
              this.authService.removeToken();
              this.authService.removeAuthToken();
              this.sharedDataService.saveUser(null);
              this.router.navigateByUrl('login');
            }
            this.socket.connectSocket();

            moment.tz.setDefault(user.company && user.company.timeZone? user.company.timeZone : user.timeZone);

            if (route.data && route.data.role) {
              let roles = user.roles;
              if (typeof user.roles === "object") {
                roles = user.roles[0];
              }
              this.sharedDataService.saveUser(user);

              if (roles === UserRoles.FULLACCESS && user.sRoles && route.data.role.includes(user.sRoles)) {
                return true;
              }else if (roles === UserRoles.FULLACCESS && route.data.role.includes(roles) && !user.sRoles) {
                return true;
              }else if (roles === UserRoles.ADMIN  && route.data.role.includes(roles)) {
                return true;
              } else if (roles === UserRoles.ADMIN ) {
                this.router.navigate(['/credentialing/companies']);
                return false;
              } else if (user.sRoles && [UserRoles.CALL_CENTER_REP,UserRoles.ACCOUNTANT].includes(user.sRoles)) {
                this.router.navigate(['/trips']);
                return false;
              }else if (user.sRoles && [UserRoles.CALL_CENTER_REP,UserRoles.CREDENTIAL].includes(user.sRoles)) {
                this.router.navigate(['/credentialing/drivers']);
                return false;
              } else {
                this.router.navigate(['/']);
                return false;
              }

            } else {
              this.sharedDataService.saveUser(null);
              this.socket.disconnectSocket();
              localStorage.removeItem('token');
              this.authService.removeAuthToken();
              this.router.navigate(['/login']);
              return false;
            }

          } else {
            this.sharedDataService.saveUser(null);
            this.socket.disconnectSocket();
            localStorage.removeItem('token');
            this.authService.removeAuthToken();
            this.router.navigate(['/login']);
            return false;
          }
        }),
        catchError((error) => {
          this.sharedDataService.saveUser(null);
          this.socket.disconnectSocket();
          localStorage.removeItem('token');
          this.authService.removeAuthToken();
          this.router.navigate(['/login']);
          return of(false);
        })
      );

  }
}

